(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-morning-ritual"] && !Shopify.designMode) return;
  try {
    
function initializeMorningRitual(root) {
  if (root.dataset.mrReady) return;
  root.dataset.mrReady = 'true';
  const hero = root.querySelector('.mr-hero-photo');
  const surface = root.querySelector('.mr-main-image');
  const thumbs = Array.from(root.querySelectorAll('.mr-thumb'));
  const controls = root.querySelector('.mr-gallery-controls');
  const count = root.querySelector('.mr-gallery-count');
  let selectedIndex = 0;
  const selectImage = index => {
    selectedIndex = (index + thumbs.length) % thumbs.length;
    const button = thumbs[selectedIndex];
    if (hero.getAttribute('src') !== button.dataset.image) {
      hero.removeAttribute('srcset');
      hero.src = button.dataset.image;
    }
    hero.alt = button.dataset.alt;
    thumbs.forEach(thumb => {
      const selected = thumb === button;
      thumb.classList.toggle('is-current', selected);
      thumb.setAttribute('aria-pressed', String(selected));
    });
    if (count) count.textContent = `${selectedIndex + 1} / ${thumbs.length}`;
  };
  if (hero && surface && thumbs.length) {
    hero.draggable = false;
    thumbs.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
    if (controls && thumbs.length > 1) {
      controls.hidden = false;
      if (count) count.textContent = `1 / ${thumbs.length}`;
      root.querySelector('.mr-gallery-previous').addEventListener('click', () => selectImage(selectedIndex - 1));
      root.querySelector('.mr-gallery-next').addEventListener('click', () => selectImage(selectedIndex + 1));
      let gesture = null;
      surface.addEventListener('pointerdown', event => {
        if (!event.isPrimary) { gesture = null; return; }
        if (event.target.closest('button') || (event.pointerType === 'mouse' && event.button !== 0)) return;
        gesture = {id:event.pointerId, x:event.clientX, y:event.clientY};
        surface.setPointerCapture(event.pointerId);
      });
      surface.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.4) selectImage(selectedIndex + (dx < 0 ? 1 : -1));
      });
      surface.addEventListener('pointercancel', () => { gesture = null; });
      surface.addEventListener('lostpointercapture', () => { gesture = null; });
    }
  }
  root.querySelectorAll('a[href^="#mr-detail-"]').forEach(link => link.addEventListener('click', () => {
    const target = root.querySelector(link.getAttribute('href'));
    if (target) { target.setAttribute('tabindex', '-1'); target.focus({preventScroll:true}); }
  }));
  const sticky = root.querySelector('.mr-sticky');
  const heroBuy = root.querySelector('.mr-buy .mr-form');
  const finalBuy = root.querySelector('.mr-closing .mr-form');
  if (sticky && heroBuy && 'IntersectionObserver' in window) {
    let pastHero = false;
    let heroVisible = false;
    let finalVisible = false;
    const update = () => { sticky.hidden = heroVisible || finalVisible || (!pastHero && !window.matchMedia('(max-width: 760px)').matches); };
    new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === heroBuy) { heroVisible = entry.isIntersecting; pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0; }
        if (entry.target === finalBuy) finalVisible = entry.isIntersecting;
      }
      update();
    }, {threshold:0}).observe(heroBuy);
    if (finalBuy) new IntersectionObserver(entries => { finalVisible = entries[0].isIntersecting; update(); }, {threshold:0}).observe(finalBuy);
  }
}
document.querySelectorAll('.mr-page').forEach(initializeMorningRitual);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.mr-page').forEach(initializeMorningRitual));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
